import React from "react";
import { uniqueId } from "../utils";

const SearchBar = ({ globalFilter, setGlobalFilter }) => {

  const inputRef = React.useRef(null)
  
  const handleInputChange = ( event ) => {
    const { value } = event.target
    setGlobalFilter( value )
  }

  return (
    <div className="msync-searchbar">
      <input
        type='search'
        id={ uniqueId() } 
        placeholder='Search...'
        value={ globalFilter }
        onChange={ (event) => handleInputChange( event ) }
        ref={inputRef}
      />
    </div>
  )

}

export default SearchBar
